import React from 'react';
import {
  Box,
  Button,
  Menu,
  MenuItem,
  MenuOverlay,
  MoreHorizontalIcon,
} from '@razorpay/blade/components';
import Breadcrumb from 'components/ui/Breadcrumb';
import { ErrorWithRetry } from 'components/ui/ErrorWithRetry';
import PageLayout from 'components/ui/Layout/PageLayout';
import { ReportPageLink } from './types';

export type ReportPageWrapperProps = React.ComponentProps<typeof PageLayout> & {
  errorMessage?: string;
  reportName?: string;
  pageLinks?: ReportPageLink[];
};

const ReportPageLinksMenu = ({ pageLinks }: { pageLinks: ReportPageLink[] }) => (
  <Menu openInteraction="click">
    <Button
      variant="tertiary"
      size="medium"
      icon={MoreHorizontalIcon}
      accessibilityLabel="More report links"
    />
    <MenuOverlay>
      {pageLinks.map((link) => (
        <MenuItem key={link.href} title={link.label} href={link.href} />
      ))}
    </MenuOverlay>
  </Menu>
);

export const ReportPageWrapper = ({
  reportName,
  errorMessage,
  pageLinks,
  children,
  ...props
}: ReportPageWrapperProps) => {
  const hasPageLinks = Boolean(pageLinks?.length);
  return (
    <PageLayout
      hideHeading
      withoutBackgroundImg
      boxProps={{
        paddingX: 'spacing.7',
      }}
      containerProps={{
        paddingBottom: '100px',
      }}
      {...(reportName
        ? {
            breadcrumb: (
              <Box
                padding="spacing.7"
                {...(hasPageLinks
                  ? {
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }
                  : {})}>
                <Breadcrumb
                  listPadding="0px"
                  listPosition="relative"
                  name={reportName}
                  urlMaps={{
                    Reports: `/reports`,
                  }}
                  className="pt-0 pb-0"
                />
                {hasPageLinks && pageLinks ? <ReportPageLinksMenu pageLinks={pageLinks} /> : null}
              </Box>
            ),
          }
        : {})}
      {...props}>
      {errorMessage ? (
        <ErrorWithRetry
          title={'Uh Oh, Some error occurred :('}
          description={<Box>{errorMessage}</Box>}
        />
      ) : null}
      {children}
    </PageLayout>
  );
};
